import { render, staticRenderFns } from "./videomode.vue?vue&type=template&id=6845d16e&scoped=true"
import script from "./videomode.vue?vue&type=script&lang=ts"
export * from "./videomode.vue?vue&type=script&lang=ts"
import style0 from "./videomode.vue?vue&type=style&index=0&id=6845d16e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6845d16e",
  null
  
)

export default component.exports